
































































import { defineComponent, ref, computed } from '@vue/composition-api';
import { i18n } from '@tt4b/ttam-i18n';
import { utm2TextMapObj } from './const';
import { useValidate } from './hooks';

const name = 'ttam-creative-utm-param-row';

export default defineComponent({
  name,
  props: {
    isFieldPlainText: {
      type: Boolean,
      default: false,
    },
    isValueAutoComplete: {
      type: Boolean,
      default: false,
    },
    canDelete: {
      type: Boolean,
      default: false,
    },
    field: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    const { utmValueValidator, customFieldValidator, customValueValidator } = useValidate();

    const dropDownMenuVisible = ref(false);

    const handleFetchSuggestions = (queryString, callback) => {
      const MACROS = [
        { value: '__CAMPAIGN_NAME__' },
        { value: '__CAMPAIGN_ID__' },
        { value: '__AID_NAME__' },
        { value: '__AID__' },
        { value: '__CID_NAME__' },
        { value: '__CID__' },
        { value: '__PLACEMENT__' },
      ];
      callback(MACROS);
    };

    const utmPlaceholderMap = computed(() => {
      const getUtmPlaceholder = () => ({
        utm_source: i18n.t('creative_utm_source_dropdown_placeholder'),
        utm_medium: i18n.t('creative_utm_source_dropdown_placeholder'),
        utm_content: i18n.t('creative_utm_source_dropdown_placeholder'),
        utm_campaign: i18n.t('creative_utm_source_dropdown_placeholder'),
      });
      return getUtmPlaceholder();
    });

    const utm2TextMap = computed(() =>
      Object.entries(utm2TextMapObj).reduce((obj, item) => {
        obj[item[0]] = item[1]();
        return obj;
      }, {}),
    );

    const handleFieldChange = newValue => {
      emit('field-change', newValue);
    };

    const handleValueChange = newValue => {
      emit('value-change', newValue);
    };

    const handleDelete = () => {
      emit('delete');
    };

    const handleFocus = () => {
      dropDownMenuVisible.value = true;
    };

    const handleBlur = () => {
      dropDownMenuVisible.value = false;
    };

    return {
      name,
      utm2TextMap,
      handleFetchSuggestions,
      utmPlaceholderMap,
      handleFieldChange,
      handleValueChange,
      handleDelete,
      handleFocus,
      handleBlur,
      dropDownMenuVisible,
      utmValueValidator,
      customFieldValidator,
      customValueValidator,
    };
  },
});
